<template>

	<anchor-container use-dot-nav>
		<template slot-scope="anchorData">
			<Layout mastheadBackground="pd/100001/sb_loop">
				<template slot="preHeadline">Sync<mark>Blasts</mark></template>
				<template slot="headline">Cross-Curricular,<br />Inquiry-Based,<br />Reading and Writing Solution</template>

				<template slot="nav">
					<SectionNav>
						<template slot="navTitle">Sync<mark>Blasts</mark></template>
						<template slot="navList">
							<ul>
								<li v-for="(component, key) in anchorData.anchors" :key="key">
									<anchor-link :to="key">{{component.title}}</anchor-link>
								</li>
							</ul>
						</template>
					</SectionNav>
				</template>

				<template slot="body">

					<anchor-content el="section" anchor="sbl-content" title="Content">
						<SectionHeadline>
							<template slot="subHeadline">Current Events, Science &amp; Social Studies Content</template>
							<template slot="headline">The Most Engaging way to build critical thinking, writing, and research skills.</template>
							<template slot="content">SyncBlasts™ provides reading and writing assignments that present social studies, science and current event topics relevant to students’ lives and their world. Providing a variety of rich multimedia, including a news show, video previews, and Explainer videos, is an engaging and smart way to build critical thinking, writing, and research skills.<br /><br /></template>
						</SectionHeadline>
						<ImageRow>
							<template slot="items">
								<li>
									<figure>
										<img src="~img/blast/build-blast2.jpg">
									</figure>
									<p><strong>Build</strong> vital research, writing, and critical thinking skills while providing an easy entry point for peer review.</p>
								</li>
								<li>
									<figure>
										<img src="~img/blast/develop-blast2.jpg">
									</figure>
									<p><strong>Develop</strong> informed opinions on high-interest topics of cultural significance.</p>
								</li>
								<li>
									<figure>
										<img src="~img/blast/express-blast2.jpg">
									</figure>
									<p><strong>Express</strong> opinions succinctly, in a familiar format, utilizing game-like features.</p>
								</li>
								<li>
									<figure>
										<img src="~img/blast/participate-blast2.jpg">
									</figure>
									<p><strong>Participate</strong> in thoughtful discussions with an authentic audience of peers.</p>
								</li>
							</template>
						</ImageRow>
						<ImageTextCta>
							<template slot="image"><img src="~img/blast/sb_promo.jpg"></template>
							<template slot="action">
								<button @click.prevent="$store.commit('app/setActiveVideoModal', 'pd/100001/sb_promo1')"><img src="~img/play.png"></button>
							</template>
							<template slot="entrys">
								<h4>Watch the SyncBlasts Promo Video</h4>
								<h2>A Revolutionary New Platform!</h2>
								<p style="margin-top: -15px;">SyncBlasts is a journalistic, educational, media product for the next generation of readers and thinkers. SyncBlasts is the answer to living in a modern, complex world, surrounded by a constant flow of information. Our students share opinions and ideas everyday. Their voices matter and so do their sources. SyncBlasts helps develop those voices and the skills necessary to succeed in this new world. </p>
							</template>
						</ImageTextCta>
						<ImageTextCta>
							<template slot="headline">Hundreds of articles, videos, and research at your fingertips</template>
							<template slot="entrys">
								<CheckList>
									<template slot="listItems">
										<li>
											<h3>New SyncBlasts Added Regularly</h3>
											<p>Save time with vetted, age-appropriate, compelling content.</p>
										</li>
										<li>
											<h3>Reading and Writing Development</h3>
											<p>Provide quick reading and writing opportunities within the context of social studies and science.</p>
										</li>
										<li>
											<h3>Standards-aligned</h3>
											<p>Reading Comprehension, QuikPoll and compelling discussion questions support student inquiry.</p>
										</li>
										<li>
											<h3>Constructive Reviews</h3>
											<p>Provides a controlled environment for constructive anonymous peer review and collaborative topic discussion.</p>
										</li>
									</template>
								</CheckList>
							</template>
							<template slot="image"><img src="~img/blast/tablets-blast3.jpg"></template>
						</ImageTextCta>
					</anchor-content>

					<anchor-content el="section" anchor="sbl-media" title="Media">
						<SectionHeadline class="centered">
							<template slot="subHeadline">Engaging Media</template>
							<template slot="headline">Supporting student inquiry and discussion</template>
							<template slot="content">Our SyncBlasts product includes multimedia components such as Preview videos that highlight background information relevant to the SyncBlast topic, Explainer videos that describe ideas in a simple manner, and additional video content that helps students build a complete understanding of the topic and construct informed responses to their assignments.</template>
						</SectionHeadline>

						<ImageTextCta>
							<template slot="image"><img src="~img/blast/news-video2.jpg"></template>
							<template slot="action">
								<button @click.prevent="$store.commit('app/setActiveVideoModal', 'syncblasts/999999/NewtonsLaw')"><img src="~img/play.png"></button>
							</template>
							<template slot="entrys">
								<h3>The Point</h3>
								<p>These videos get to the point with news and global issues. Students watch and become engaged with newscasts produced with peer-aged students. In this episode, Monica and Theo discuss Newton's Law.</p>
							</template>
						</ImageTextCta>
						<ImageTextCta class="reversed">
							<template slot="image"><img src="~img/blast/explainer-video2.jpg"></template>
							<template slot="action">
								<button @click.prevent="$store.commit('app/setActiveVideoModal', 'syncblasts/999999/TheFirstAmendment')"><img src="~img/play.png"></button>
							</template>
							<template slot="entrys">
								<h3>Explainer Videos</h3>
								<p>Short, fact-based videos focus on explaining an idea in a simple and compelling manner. Clear, concise language is paired with visuals, quickly teaching a concept prior to a deeper dive or discussion.</p>
							</template>
						</ImageTextCta>
						<!--<ImageTextCta>
							<template slot="image"><img src="~img/blast/sync-skills2.jpg"></template>
							<template slot="action">
								<button @click.prevent="$store.commit('app/setActiveVideoModal', 'syncblasts-skills/1/video')"><img src="~img/play.png"></button>
							</template>
							<template slot="entrys">
								<h3>SyncSkills Videos</h3>
								<p>SyncSkills videos model the rigor and drama of a lively classroom discussion in a condensed and casual format. Students learn by watching peers model specific critical thinking, writing, and analytical skills.</p>
							</template>
						</ImageTextCta>-->
						<ImageTextCta>
							<template slot="image"><img src="~img/blast/preview-video1.jpg"></template>
							<template slot="action">
								<button @click.prevent="$store.commit('app/setActiveVideoModal', 'unit/172/preview')"><img src="~img/play.png"></button>
							</template>
							<template slot="entrys">
								<h3>Previews</h3>
								<p>Designed like movie trailers, Preview videos set the stage and provide background information for what is to come. Use these videos as an introduction to the subject and revisit for a big-picture view.</p>
							</template>
						</ImageTextCta>
						<!--<ImageTextCta>
							<template slot="image"><img src="~img/blast/TalkBack3.jpg"></template>
							<template slot="entrys">
								<h3>Talk Back</h3>
								<p>Students get to hear differing answers and opinions to important topics covered in their social studies, science and current events classroom instruction.</p>
							</template>
						</ImageTextCta>
						<IconContent>
							<template slot="headline">and Podcasts!</template>
							<template slot="content">Bring students’ thoughts and opinions–plus insights from teachers, experts, and innovators in education–right into the classroom! Podcasts are produced using student voices from around the country.</template>
						</IconContent>-->
					</anchor-content>

					<ImageQuoteContent :contentBackgroundImage="bgImages.accessForAll" :sideBackgroundImage="bgImages.takingTest">
						<template slot="quote">
							<blockquote>
								<!--<h4>My students cheer when I tell them it's time to do StudySync.</h4>
								<cite><i><img src="~img/amy-miles.png"></i>Amy Miles, San Diego MS Teacher</cite>-->
								<h4>&ldquo;Every time I look at SyncBlasts I get excited - it's so elegant and simple. I love it.&rdquo;</h4>
								<cite><i><img src="~img/cyndi-smith.png"></i>C.M. Brown, English Teacher</cite>
							</blockquote>
						</template>
					</ImageQuoteContent>
					<anchor-content el="section" anchor="sbl-platform" title="Platform">
						<SectionHeadline class="centered">
							<template slot="subHeadline">Superior Platform</template>
							<template slot="headline">SyncBlasts encourages social learning, collaboration and critical thinking.</template>
							<template slot="content">Our platform allows for content to be updated regularly and for teachers to seamlessly search content, make assignments, and critique student work. Students engage deeply in peer review, improving their own writing, along with the writing of other students. Comprehension questions and a Top 10 competition help students focus on their reading.</template>
						</SectionHeadline>
						<ImageTextCta class="image-center">
							<template slot="image"><img src="~img/blast/laptop-and-cellohone-combined.png"></template>
						</ImageTextCta>
					</anchor-content>
				</template>

				<template slot="footer">
					<FooterCTA />
				</template>
			</Layout>
		</template>
	</anchor-container>

</template>

<script>
	import Layout from '@/components/Products/layout'
	import SectionNav from '@/components/Products/SectionNav'
	import ImageRow from '@/components/Products/ImageRow'
	import SectionHeadline from '@/components/Products/SectionHeadline'
	import ImageQuoteContent from '@/components/Products/ImageQuoteContent'
	import FooterCTA from '@/components/FooterCTA'

	import ImageTextCta from '@/components/Products/ImageTextCta'
	import CheckList from '@/components/Products/CheckList'

	import { AnchorContainer, AnchorContent, AnchorLink } from '@/components/AnchorNav'


	export default {
		metaInfo () {
			return this.$generateMetaInfo({
				title: `SyncBlasts`,
				description: `SyncBlasts provides reading and writing assignments that present social studies, science and current event topics relevant to students' lives and their world. Providing a variety of rich multimedia, including a news show, video previews, and Explainer videos, is an engaging and smart way to build critical thinking, writing, and research skills.`,
				image: 'https://www.studysync.com/static/img/sb_promo.5f36229.jpg'
			})
		},
		routeConfig: {
			alias: '/products/syncBlast'
		},
		components: { Layout, SectionNav, SectionHeadline, ImageRow, ImageTextCta, CheckList, FooterCTA, ImageQuoteContent, AnchorContent, AnchorContainer, AnchorLink },
		data () {
			return {
				bgImages: {
					masthead: require('@/assets/img/blast/masthead.jpg'),
					takingTest: require('@/assets/img/blast/girl-phone.jpg'),
					accessForAll: require('@/assets/img/blast/class-room-masthead.jpg')
				},
			}
		}
	}

</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/routes/products/syncblasts.vue